import React from "react";
import ReactDOM from "react-dom";
import DataVizTools from "./DataVizTools";
const { BrowserRouter, Route, Switch } = require("react-router-dom");

const Routes = (
  <BrowserRouter basename={"/dataviztools"}>
    <Switch>
      <Route path="/" exact component={DataVizTools} />
    </Switch>
  </BrowserRouter>
);

ReactDOM.render(Routes, document.getElementById("app"));
